/**
 * @param {Object} props - The component props
 * @param {string | undefined} [props.className] - Optional CSS class name
 * @returns {React.ReactElement}
 */
const KabiLogo = ({ className }) => (
  <svg
    className={className}
    height="38px"
    viewBox="0 37 800 217"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="g2826" transform="matrix(1.25,0,0,-1.25,0,120)">
      <g
        id="g2984"
        transform="matrix(2.4834907,0,0,2.4834907,-82.448734,-1928.4364)"
      >
        <path
          id="path2836"
          fillRule="evenodd"
          fill="currentColor"
          d="M52.1,802.9h10.1l0.5-0.5l0.4-0.5c1.6-3,1.5-3.3,1.8-6.9
			c0-5.4-3-11.2,0.4-16.2c2.7-3,6.7-4.3,10.1-6.3l1.1-1l1-1l1-1.3l0.8-1.4l0.8-1.6l0.4-2l0.4-2.3l0.1-2.5V734H70.7v27.8l-0.4,2.3
			l-0.5,1.9l-0.8,1.6l-0.8,1.5l-1,1.1l-1,1c-2.9,2.8-7,3.5-10.4,6.6C49.3,785,59.1,794.9,52.1,802.9"
        />
        <path
          id="path2838"
          fillRule="evenodd"
          fill="currentColor"
          d="M33.2,802.9h10l0.5-0.5l0.4-0.5c1-2.1,1.9-4.5,1.6-6.9
			c0.1-5-2.5-10.2-0.1-15c1.6-3.8,7.3-5.2,10.6-7.5l2.3-2l0.9-1.3l0.8-1.4l0.8-1.6l0.4-2l0.4-2.3l0.1-2.5V734H51.6v25.3l-0.1,2.5
			l-0.4,2.3l-0.4,1.9c-1.6,3.7-1.8,3.7-4.7,6.3c-3.3,2.3-7.4,3.3-10,6.4c-3,4-0.9,10.1-0.5,14.7v3.5l-0.4,1.6L35,800l-0.5,1
			l-0.5,0.9l-0.4,0.5l-0.4,0.4L33.2,802.9"
        />
        <path
          id="path2840"
          fillRule="evenodd"
          fill="currentColor"
          d="M71.1,802.9h10.1l0.1-0.1l0.3-0.4l0.4-0.5l0.5-0.9l0.5-1l0.5-1.4
			l0.3-1.6c0.8-5.7-2.8-11.5-0.3-17.1c1.9-3.6,7.2-5.3,10.7-7.5l1-1l1.1-1l1-1.3l0.8-1.4l0.8-1.6l0.4-2l0.5-2.3V734H89.5v27.8
			l-0.4,2.3l-0.5,1.9c-1.5,4.2-1.8,3.4-4.5,6.3c-3.3,2.2-7.5,3.2-10,6.4c-3.2,4.1-1,9.9-0.6,14.7l0.1,1.5l-0.1,2l-0.3,1.6l-0.4,1.4
			l-0.5,1l-0.5,0.9l-0.4,0.5l-0.4,0.4L71.1,802.9"
        />
        <path
          id="path2842"
          fillRule="evenodd"
          fill="currentColor"
          d="M176.7,743v-4.5h5.8l0.6,0.5l0.5,0.4l0.3,0.6l0.1,0.9l-0.1,0.9
			l-0.4,0.8l-0.9,0.4l-1,0.1L176.7,743L176.7,743z M159,749.3l-2.1-6.8h4.2L159,749.3L159,749.3z M176.7,750.8v-3.7h4.7l1,0.3
			l0.6,0.3l0.4,0.6l0.1,0.8l-0.1,0.5l-0.3,0.5l-0.4,0.4l-0.6,0.3l-0.8,0.1L176.7,750.8L176.7,750.8z M192.7,755.1h5.4V734h-5.4
			V755.1z M171.5,755.1h10.1l1.9-0.1l1.6-0.4l1.4-0.5l1-0.9l0.6-0.9c1.1-2.6,0.8-5.5-1.9-6.8c3.1-1.6,3.2-3.1,2.9-6.4l-0.5-1.4
			l-0.9-1.3l-1.1-1l-1.4-0.8l-1.8-0.4l-2-0.3h-10L171.5,755.1L171.5,755.1z M156.2,755.1h5.4l7.7-21.1h-5.7l-1.3,4.2h-7.1l-1.1-4.2
			h-5.7L156.2,755.1L156.2,755.1z M128.4,755.1h5.4v-8l6.3,8h6.4l-6.3-7.3l7.3-13.8h-6.4l-4.8,9.5l-2.5-3.2V734h-5.4L128.4,755.1"
        />
        <path
          id="path2844"
          fillRule="evenodd"
          fill="currentColor"
          d="M151.6,782.3v-4.8h5.2l0.8,0.4l0.6,0.5l0.3,0.8l0.1,0.9l-0.1,0.8
			l-0.3,0.6l-0.6,0.5l-0.8,0.3l-1,0.1L151.6,782.3L151.6,782.3z M253.6,786.8h5.4v-13.4l0.4-1l0.5-1l0.6-0.6l1-0.5l1.1-0.1l1,0.1
			l0.9,0.5l0.8,0.6l0.5,1l0.3,1l0.1,1.4v12h5.4c-0.6-8,3.3-21.3-9-21.3C250.3,765.5,254.2,778.7,253.6,786.8L253.6,786.8z
			 M244.7,786.8h5.4v-21.1h-5.4V786.8z M222.7,786.8h4.8l8.2-11.5v11.5h5.1v-21.1h-4.3l-8.6,12.1v-12.1h-5.2L222.7,786.8
			L222.7,786.8z M204.1,786.8h15.3v-4.7h-10v-3h6.7v-4.5h-6.7v-4.3h10.7v-4.5h-16V786.8L204.1,786.8z M166.8,786.8h15.3v-4.7h-10v-3
			h6.7v-4.5h-6.7v-4.3h10.7v-4.5h-16V786.8L166.8,786.8z M146.3,786.8h11.2l1.6-0.4l1.3-0.5l1.3-0.6l0.9-1l0.8-1.1
			c1.2-3.7,0.4-7.7-3.4-9.3l4.2-8.1h-5.9l-3.5,7.3h-3v-7.3h-5.3L146.3,786.8L146.3,786.8z M128.4,786.8h15.8v-4.7h-10.5V779h7.5
			v-4.8h-7.5v-8.5h-5.3V786.8z M282.4,787.2c3.7-0.1,5.1-0.4,8.1-2.7l-2.8-4l-1.4,0.9l-1.3,0.6l-1.4,0.3l-1.5,0.1h-1l-0.8-0.3
			l-0.4-0.4l-0.3-0.4l-0.1-0.5l0.1-0.4l0.4-0.5l0.6-0.3c2.4-0.8,4.7-1.2,7.1-2.3c3.9-1.9,3.9-7.8,0.9-10.4
			c-3.8-2.9-11.7-1.8-15.2,1.3l2.9,3.8c7.8-5,13.3,0.4,5.1,1.9C270.5,775.5,273,787.7,282.4,787.2L282.4,787.2z M192.7,787.2
			c4-0.1,4.9-0.5,8.2-2.7l-2.9-4l-1.3,0.9l-1.4,0.6l-1.4,0.3l-1.5,0.1h-1l-0.8-0.3l-0.4-0.4l-0.3-0.4l-0.1-0.5l0.1-0.4l0.4-0.5
			l0.8-0.3c2.2-0.8,4.7-1.2,6.9-2.3c3.8-1.9,4-7.9,0.8-10.4c-3.8-2.9-11.6-1.8-15,1.3l3,3.8l1.1-0.8l1.5-0.6l1.6-0.5l1.6-0.1h1.1
			l0.9,0.1l0.5,0.4c1.9,2.4-2,3-3.5,3.4C181.1,775.4,183.1,787.5,192.7,787.2"
        />
      </g>
    </g>
  </svg>
);

export default KabiLogo;
